import React, {
    useEffect,
    useState
} from 'react';
import api from '../services/api';
import '../styles/CompanyDashboard.css';

export default function Contacts() {
    const [companies, setCompanies] = useState([]);
    const [contacts, setContacts] = useState([]);
    const [selectedCompanyId, setSelectedCompanyId] = useState(null);
    const [newContact, setNewContact] = useState({
        name: '',
        position: '',
        email: '',
        phone: '',
        mobile: '',
        details: {}
    });
    const [detailPairs, setDetailPairs] = useState([{key: '', value: ''}]);
    const [selectedDetails, setSelectedDetails] = useState(null);
    const [searchTerm, setSearchTerm] = useState("");

    useEffect(() => {
        loadCompanies();
        loadContacts();
    }, []);

    const loadCompanies = () => {
        api.get('/Company').then(res => setCompanies(res.data));
    };

    const loadContacts = () => {
        api.get('/Contact').then(res => setContacts(res.data));
    };


    const handleShowDetails = (contact) => {
        try {
            const parsed = JSON.parse(contact.details);
            setSelectedDetails({contact, parsed});
        } catch (e) {
            alert("Details konnten nicht gelesen werden.");
        }
    };

    const filteredCustomers = companies.filter(p =>
        (p.name && p.name.toLowerCase().includes(searchTerm.toLowerCase()))
    );

    const handleAddContact = () => {
        if (!selectedCompanyId || !newContact.name) return;

        const detailsJson = {};
        detailPairs.forEach(p => {
            if (p.key.trim()) detailsJson[p.key] = p.value;
        });

        api.post('/contact', {
            name: newContact.name,
            position: newContact.position,
            email: newContact.email,
            phoneNumber: newContact.phone,
            mobileNumber: newContact.mobile,
            companyId: selectedCompanyId,
            details: JSON.stringify(detailsJson)
        }).then(() => {
            setNewContact({name: '', email: '', position: '', phone: '', mobile: '', details: {}});
            setDetailPairs([{key: '', value: ''}]);
            loadContacts();
        }).catch((err) => {
            console.error(err);
            alert("Fehler beim Erstellen des Kontakts.");
        });
    };

    const handleDeleteContact = (id) => {
        if (window.confirm("Kontakt wirklich löschen?")) {
            api.delete(`/contact/${id}`).then(loadContacts);
        }
    };

    const handleDetailChange = (index, field, value) => {
        const updated = [...detailPairs];
        updated[index][field] = value;
        setDetailPairs(updated);
    };

    const addDetailPair = () => {
        setDetailPairs([...detailPairs, {key: '', value: ''}]);
    };

    const filteredContacts = selectedCompanyId
        ? contacts.filter(c => c.companyId === selectedCompanyId)
        : [];

    return (
        <div className="company-dashboard">
            <div className="company-list">
                <h3>Kunden</h3>

                <input
                    type="text"
                    placeholder="Kunde suchen..."
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                    className="company-search"
                />

                <ul className="contact-list">
                    {filteredCustomers.map(company => (
                        <li
                            key={company.id}
                            className={company.id === selectedCompanyId ? 'selected' : ''}
                            onClick={() => setSelectedCompanyId(company.id)}
                        >
                            <strong>{company.name}</strong><br/>
                            {company.address}
                        </li>
                    ))}
                </ul>


            </div>

            <div className="contact-section">
                <h3>Kontakte</h3>

                {selectedCompanyId && (
                    <div className="contact-form">
                        <div className="form-grid">
                            <div className="form-group">
                                <label>Name</label>
                                <input
                                    value={newContact.name}
                                    onChange={e => setNewContact({...newContact, name: e.target.value})}
                                />
                            </div>
                            <div className="form-group">
                                <label>Position</label>
                                <input
                                    value={newContact.position}
                                    onChange={e => setNewContact({...newContact, position: e.target.value})}
                                />
                            </div>
                            <div className="form-group">
                                <label>E-Mail</label>
                                <input
                                    value={newContact.email}
                                    onChange={e => setNewContact({...newContact, email: e.target.value})}
                                />
                            </div>
                            <div className="form-group">
                                <label>Telefon</label>
                                <input
                                    value={newContact.phone}
                                    onChange={e => setNewContact({...newContact, phone: e.target.value})}
                                />
                            </div>
                            <div className="form-group">
                                <label>Mobil</label>
                                <input
                                    value={newContact.mobile}
                                    onChange={e => setNewContact({...newContact, mobile: e.target.value})}
                                />
                            </div>
                        </div>

                        <div className="details-grid">
                            <label>Details</label>
                            {detailPairs.map((pair, index) => (
                                <div className="details-row" key={index}>
                                    <input
                                        placeholder="Key"
                                        value={pair.key}
                                        onChange={e => handleDetailChange(index, 'key', e.target.value)}
                                    />
                                    <input
                                        placeholder="Value"
                                        value={pair.value}
                                        onChange={e => handleDetailChange(index, 'value', e.target.value)}
                                    />
                                    <button onClick={addDetailPair}>+</button>
                                </div>
                            ))}
                        </div>

                        <div className="form-buttons">
                            <button onClick={handleAddContact}>Kontakt hinzufügen</button>
                        </div>
                    </div>
                )}

                {filteredContacts.length > 0 ? (
                    <div className="table-wrapper">
                        <table className="table">
                            <thead>
                            <tr>
                                <th>Name</th>
                                <th>Position</th>
                                <th>E-Mail</th>
                                <th>Telefon</th>
                                <th>Mobil</th>
                                <th>Aktionen</th>
                            </tr>
                            </thead>
                            <tbody>
                            {filteredContacts.map(contact => (
                                <tr key={contact.id}>
                                    <td>{contact.name}</td>
                                    <td>{contact.position}</td>
                                    <td>{contact.eMail}</td>
                                    <td>{contact.phoneNumber}</td>
                                    <td>{contact.mobileNumber}</td>
                                    <td>
                                        <button onClick={() => handleDeleteContact(contact.id)}>🗑️</button>
                                        <button onClick={() => handleShowDetails(contact)}>🔍</button>
                                    </td>
                                </tr>
                            ))}
                            </tbody>
                        </table>
                    </div>
                ) : (
                    <p>Keine Kontakte für diesen Kunden.</p>
                )}

                {selectedDetails && (
                    <div className="sidebar_details">
                        <h4>Details von {selectedDetails.contact.name}</h4>
                        <table className="table">
                            <tbody>
                            {Object.entries(selectedDetails.parsed).map(([key, value], index) => (
                                <tr key={index}>
                                    <td><strong>{key}</strong></td>
                                    <td>{value}</td>
                                </tr>
                            ))}
                            </tbody>
                        </table>
                        <button className="button button-danger" onClick={() => setSelectedDetails(null)}>Schließen
                        </button>
                    </div>
                )}
            </div>
        </div>
    );
}
